import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const MenuListing = lazyWithRetry(() => import('./MenuListing'));
const MenuEditor = lazyWithRetry(() => import('./MenuEditorV3/MenuEditor'));

type Props = RouteComponentProps;

const MenuRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="restaurant-menus">
      <Switch>
        <Route
          path={`${path}/menu-editor`}
          render={() => (
            <LazyComponent>
              <MenuEditor />
            </LazyComponent>
          )}
        />
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <MenuListing />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default MenuRoutes;
